export default {"src":"/_next/static/media/urinary_retention.9ac0790a.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};